import type {
  PreparedBarometerAuction,
} from '@autobid/ui/types/components/AuctionsData'
import type { BarometerAuction } from '../types/Car'
import { getError } from '@autobid/strapi-integration/utils/getError'
import { convertSingleAuction } from '@autobid/ui/utils/auctions/convertDataToDisplay'

function prepareFetchAuction(rawAuctionsData: BarometerAuction, lang: string) {
  const data = [rawAuctionsData]
  const auction = convertSingleAuction({
    data,
    lang,
  })

  return auction[0]
}

export function useGetAuctionFetcher() {
  const { $trpc } = useNuxtApp()

  const fetchAuction = async (
    id: string | number,
    lang: string,
  ): Promise<PreparedBarometerAuction | null> => {
    if (typeof id !== 'number' || Number.isNaN(id)) {
      return null
    }

    try {
      const rawAuctionsData = await $trpc.auctions.getSingleAuction.query({ id, lang })

      if (!rawAuctionsData.data?.singleAuction?.item) {
        return null
      }

      return prepareFetchAuction(rawAuctionsData.data.singleAuction.item, lang)
    }
    catch (error) {
      const { message, code, handled } = getError(error)

      if (!handled) {
        throw createError({ statusCode: code, statusMessage: message })
      }

      return null
    }
  }

  return { fetchAuction }
}
